<template>
    <BreadCrumb PageTitle="Rechargement par Stripe" />
    <RechargeStripe/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import RechargeStripe from "@/components/Compte/RechargeStripe.vue";
  
    export default defineComponent({
      name: "RechargeStripePage",
      components: {
        BreadCrumb,
        RechargeStripe,
      },
    });
  </script>